import i18n from "@/i18n";
import dict from "@/i18n/extra.json";

export const tx = (s) => {
  const lang = (i18n.language || "it").slice(0, 2);
  return (lang !== "it" && dict[lang] && dict[lang][s]) || s;
};

const LOCALES = { it: "it-IT", en: "en-GB", fr: "fr-FR", es: "es-ES", de: "de-DE" };
export const loc = () => LOCALES[(i18n.language || "it").slice(0, 2)] || "it-IT";
